<template>
  <div class="explore">
    <div v-if="showRenderTimer" class="render-status" role="status" aria-live="polite">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
      <div class="render-status__label">
        {{ isLoading ? "Loading explore data" : "Rendering explore page" }}
      </div>
      <div class="render-status__timer">
        {{ formattedRenderTime }} ({{ renderProgress }}%)
      </div>
    </div>

    <div v-if="!isLoading" ref="exploreContent">
      <div class="menu">
        <li><a :class="selectedView == 'ethols' ? 'black' : '-'" href="javascript:void(0);" @click="selectedView='ethols'">Ethols</a></li>
        <li><a :class="selectedView == 'holders' ? 'black' : '-'" href="javascript:void(0);" @click="selectedView='holders'">Holders</a></li>
      </div>
      
      <div v-show="selectedView == 'ethols'">
        <input v-model="enteredId" placeholder="etholvant #" min="0" />
        <input v-model="minCellsFilter" placeholder="min # of cells" />
        <input v-model="maxCellsFilter" placeholder="max # of cells" />
        <div class="etholCont">
          <div
            v-for="tokenId in visibleTokenIds"
            :key="tokenId"
            class="cont-inline"
            :data-token-id="tokenId"
          >
            <div
              class="ethol"
              @click="selectEthol(tokenId, $event)"
              :class="{ selected: selectedId == tokenId }"
            >
              <img
                class="crown"
                v-if="tokenId == tokenIds[0]"
                src="../assets/crown.png"
              />
              <div v-show="animatedHist.tokenId != tokenId">
                <canvas
                  v-show="imgSources[tokenId]"
                  :ref="'etholCanvas' + tokenId"
                ></canvas>
                <div v-if="!imgSources[tokenId]" class="ethol-img-placeholder"></div>
                <div class="caption">
                  #{{ tokenId }} - {{ etholdata.etholvants[tokenId][1] }} cells
                  <br />
                  {{ etholdata.etholvants[tokenId][3] }} cells / 4hr
                </div>
              </div>
              <div v-show="animatedHist.tokenId == tokenId">
                <canvas :ref="'animatedCanvas' + tokenId"></canvas>
                <div class="caption">
                  #{{ tokenId }} - {{ animatedHist.numCells }} cells
                </div>
              </div>
              <div v-if="selectedId == tokenId">
                <br />
                <div class="option">
                  <a @click.stop="downloadScaled(tokenId)" href="javascript:void(0);">Download</a>
                </div>
                <div class="option">
                  <a
                    :href="
                      'https://opensea.io/assets/0x1fff1e9e963f07ac4486503e5a35e71f4e9fb9fd/' +
                      tokenId
                    "
                    target="_blank"
                    >View on OpenSea</a
                  >
                </div>
                <div class="option">
                  <a
                    @click.stop="animateHistory(tokenId)"
                    href="javascript:void(0);"
                    >See Evolution</a
                  >
                </div>
                <div class="option">
                  <a
                    @click="view3D(tokenId)"
                    href="javascript:void(0);"
                    >View 3D</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttonsCont">
          <button @click="firstPage">First</button>
          <button @click="prevPage">&#8249;</button>
          <button @click="nextPage">&#8250;</button>
          <button @click="lastPage">Last</button>
        </div>
        <div v-show="etholdata.timestamp" class="caption">
          Updated
          {{ Math.floor((Date.now() / 1000 - etholdata.timestamp) / 60) }} minutes
          ago.
        </div>
        <div class="pageNum">
          Page {{ index / pageSize + 1 }} of
          {{ Math.floor(this.sortedIds.length / this.pageSize) + 1 }} -
          {{ this.sortedIds.length }} results
        </div>
        <br />
      </div>
      <div class="holdersDiv" v-if="selectedView == 'holders'">
        <p>
          <a style="font-size: 14px;" @click.stop="showTableInfo = !showTableInfo" href="javascript:void(0);"
            >Table Info</a
          >
        </p>
        <div class="table-info" v-show="showTableInfo">
          <p>Ethols: Total etholvant count.</p>
          <p>Cells: Total cell count.</p>
          <p>Growth: Total growth rate / 4hr if all staked.</p>
          <p>Click on any header to sort by that column.</p>
          <p>Click on any address to copy it.</p>
        </div>
        <table>
          <tbody>
            <tr>
              <td>#</td>
              <td>Address</td>
              <td :class="{selectedSort: tableSortBy == 'etholCount', clickable: true}" @click="tableSortBy='etholCount'">Ethols</td>
              <td :class="{selectedSort: tableSortBy == 'cellCount', clickable: true}" @click="tableSortBy='cellCount'">Cells</td>
              <td :class="{selectedSort: tableSortBy == 'growthRate', clickable: true}" @click="tableSortBy='growthRate'">Growth</td>
            </tr>
            <tr v-for="(holder, index) in holders" :key="holder">
              <td>{{ index + 1 }}</td>
              <td class="clickable" @click="copyText(holder)">{{ holder.substring(0, 10) }}</td> 
              <td>{{ holdersData.etholCount[holder] }}</td>
              <td>{{ holdersData.cellCount[holder] }}</td>  
              <td>{{ holdersData.growthRate[holder] }}</td>  
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  drawCanvas,
  drawToCanvasAsync,
  disposeDrawWorkers,
  addOffsets,
  drawOffsetsToCanvas,
} from "../drawer";

export default {
  name: "Explore",
  props: {},
  components: {},
  data() {
    return {
      etholdata: {},
      isLoading: false,
      isRenderingPage: false,
      renderStartedAt: null,
      renderElapsedMs: 0,
      renderProgress: 0,
      renderTimer: null,
      renderFrame: null,
      renderCycle: 0,
      layoutAnimationTimer: null,
      sortedIds: [],
      tokenIds: [],
      imgSources: {},
      renderedCanvases: {},
      renderedCanvasOrder: [],
      renderedCanvasLimit: 120,
      index: null,
      pageSize: 12,
      enteredId: "",
      selectedId: null,
      minCells: null,
      maxCells: null,
      minCellsFilter: null,
      maxCellsFilter: null,
      selectedView: "ethols",
      holdersData: null,
      holders: null,
      showTableInfo: false,
      tableSortBy: "cellCount",
      script3d: atob('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'),

      animatedHist: {
        tokenId: null,
        numCells: null,
      },
    };
  },

  mounted() {
    this.fetchData();
  },

  beforeUnmount() {
    this.stopRenderTimer();
    if (this.layoutAnimationTimer) {
      clearTimeout(this.layoutAnimationTimer);
      this.layoutAnimationTimer = null;
    }
    disposeDrawWorkers();
  },

  computed: {
    formattedRenderTime() {
      return (this.renderElapsedMs / 1000).toFixed(1) + "s";
    },

    showRenderTimer() {
      return this.isLoading || this.isRenderingPage;
    },

    visibleTokenIds() {
      return this.sortedIds.slice(this.index, this.index + this.pageSize);
    },
  },

  watch: {
    enteredId: function () {
      this.applyFilters();
    },

    minCellsFilter: function () {
      this.applyFilters();
    },

    maxCellsFilter: function () {
      this.applyFilters();
    },

    tableSortBy: function () {
      this.sortTable();
    },

    selectedView: function () {
      if (this.selectedView == "ethols") {
        this.startPageRender();
      }
    },
  },

  methods: {
    startRenderTimer() {
      this.stopRenderTimer();
      this.renderCycle += 1;
      this.renderStartedAt = Date.now();
      this.renderElapsedMs = 0;
      this.renderProgress = 0;
      this.renderTimer = setInterval(() => {
        this.renderElapsedMs = Date.now() - this.renderStartedAt;
      }, 100);
    },

    stopRenderTimer() {
      if (this.renderTimer) {
        clearInterval(this.renderTimer);
        this.renderTimer = null;
      }
      if (this.renderFrame) {
        cancelAnimationFrame(this.renderFrame);
        this.renderFrame = null;
      }
    },

    startPageRender() {
      this.startRenderTimer();
      this.isRenderingPage = true;
      this.finishInitialRender();
    },

    async generateImg(tokenId, onProgress) {
      await this.$nextTick();
      var canvas = this.getEtholCanvas(tokenId);
      if (!canvas) {
        return;
      }

      if (this.hasRenderedImage(tokenId, canvas)) {
        return;
      }

      if (this.copyCachedImage(tokenId, canvas)) {
        this.imgSources[tokenId] = true;
        if (onProgress) {
          onProgress(1, 1);
        }
        return;
      }

      var renderedCanvas = document.createElement("canvas");
      await drawToCanvasAsync(
        this.etholdata.etholvants[tokenId][0],
        this.etholdata.etholvants[tokenId][1],
        this.etholdata.etholvants[tokenId][2],
        renderedCanvas,
        onProgress
      );
      this.cacheRenderedImage(tokenId, renderedCanvas);
      this.copyCachedImage(tokenId, canvas);
      this.imgSources[tokenId] = true;
    },

    hasRenderedImage(tokenId, canvas) {
      var source = this.etholdata.etholvants[tokenId];
      if (!source) {
        return false;
      }

      var target = canvas || this.getEtholCanvas(tokenId);
      return (
        this.imgSources[tokenId] &&
        target &&
        target.width == source[2] &&
        target.height == source[2]
      );
    },

    copyCachedImage(tokenId, canvas) {
      var cachedCanvas = this.renderedCanvases[tokenId];
      if (!cachedCanvas || !canvas) {
        return false;
      }

      canvas.width = cachedCanvas.width;
      canvas.height = cachedCanvas.height;
      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(cachedCanvas, 0, 0);
      this.touchRenderedImage(tokenId);
      return true;
    },

    cacheRenderedImage(tokenId, canvas) {
      this.renderedCanvases[tokenId] = canvas;
      this.touchRenderedImage(tokenId);

      while (this.renderedCanvasOrder.length > this.renderedCanvasLimit) {
        var evictedTokenId = this.renderedCanvasOrder.shift();
        if (evictedTokenId != tokenId) {
          delete this.renderedCanvases[evictedTokenId];
          delete this.imgSources[evictedTokenId];
        }
      }
    },

    touchRenderedImage(tokenId) {
      var index = this.renderedCanvasOrder.indexOf(tokenId);
      if (index !== -1) {
        this.renderedCanvasOrder.splice(index, 1);
      }
      this.renderedCanvasOrder.push(tokenId);
    },

    getEtholCanvas(tokenId) {
      var ref = this.$refs["etholCanvas" + tokenId];
      return Array.isArray(ref) ? ref[0] : ref;
    },

    getAnimatedCanvas(tokenId) {
      var ref = this.$refs["animatedCanvas" + tokenId];
      return Array.isArray(ref) ? ref[0] : ref;
    },

    async renderVisibleImages(cycle) {
      var ids = this.visibleTokenIds.filter(
        (tokenId) => !this.hasRenderedImage(tokenId)
      );
      const total = ids.length || 1;

      for (var i = 0; i < ids.length; i++) {
        if (cycle != this.renderCycle) return;

        await this.waitForPaint();
        if (cycle != this.renderCycle) return;

        await this.generateImg(ids[i], (done, count) => {
          const imageProgress = count ? done / count : 1;
          this.renderProgress = Math.min(
            99,
            Math.floor(((i + imageProgress) / total) * 100)
          );
        });
        this.renderElapsedMs = Date.now() - this.renderStartedAt;
        await this.$nextTick();
      }

      if (!ids.length) {
        this.renderProgress = 100;
      }
    },

    waitForImage(img) {
      if (img.complete) {
        if (img.decode) {
          return img.decode().catch(() => {});
        }
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        var finish = () => {
          img.removeEventListener("load", finish);
          img.removeEventListener("error", finish);
          if (img.decode) {
            img.decode().catch(() => {}).finally(resolve);
            return;
          }
          resolve();
        };

        img.addEventListener("load", finish, { once: true });
        img.addEventListener("error", finish, { once: true });
      });
    },

    waitForRenderedImages() {
      var content = this.$refs.exploreContent;
      if (!content) {
        return Promise.resolve();
      }

      var images = Array.from(content.querySelectorAll("img"));
      return Promise.all(images.map(this.waitForImage)).then(() => {});
    },

    waitForPaint() {
      return new Promise((resolve) => {
        this.renderFrame = requestAnimationFrame(() => {
          this.renderFrame = requestAnimationFrame(() => {
            this.renderFrame = null;
            resolve();
          });
        });
      });
    },

    async finishInitialRender() {
      var cycle = this.renderCycle;

      await this.$nextTick();
      if (cycle != this.renderCycle) return;

      await this.renderVisibleImages(cycle);
      if (cycle != this.renderCycle) return;

      await this.waitForRenderedImages();
      if (cycle != this.renderCycle) return;

      await this.waitForPaint();
      if (cycle != this.renderCycle) return;

      await this.waitForPaint();
      if (cycle != this.renderCycle) {
        return;
      }

      this.renderElapsedMs = Date.now() - this.renderStartedAt;
      this.renderProgress = 100;
      this.isRenderingPage = false;
      this.stopRenderTimer();
    },

    fetchData() {
      this.startRenderTimer();
      this.isLoading = true;
      fetch(
        "https://dl.dropboxusercontent.com/s/6o40ylesymwym6x/etholdata.json"
      )
        .then((response) => response.json())
        .then((data) => {
          this.etholdata = data;
          var ids = Object.keys(data["etholvants"]);
          ids.sort((a, b) =>
            data["etholvants"][a][1] < data["etholvants"][b][1] ? 1 : -1
          );
          this.tokenIds = ids;
          this.maxCells = this.etholdata["etholvants"][this.tokenIds[0]][1];
          this.minCells =
            this.etholdata["etholvants"][this.tokenIds.slice(-1)][1];
          // this.sortedIds = ids;
          this.applyFilters();
          this.index = 0;
          this.populateHolders();
        })
        .finally(() => {
          this.isRenderingPage = true;
          this.isLoading = false;
          this.finishInitialRender();
        });
    },

    populateHolders() {
      var data = this.etholdata['etholvants'];
      var etholCount = {};
      var cellCount = {};
      var growthRate = {};
      var holders = []
      Object.values(data).forEach(val => {
        var holder = val[4];
        etholCount[holder] = (etholCount[holder] || 0) + 1;
        cellCount[holder] = (cellCount[holder] || 0) + val[1];
        growthRate[holder] = (growthRate[holder] || 0) + val[3];
      });
      Object.keys(etholCount).forEach(holder => {
        if (holder != 'null') {
          holders.push(holder)
        }
      });
      this.holdersData = {
        etholCount: etholCount,
        cellCount: cellCount,
        growthRate: growthRate,
      }
      this.holders = holders;
      this.sortTable();
    },

    sortTable() {
      var sortBy;
      if (this.tableSortBy == 'cellCount') {
        sortBy = this.holdersData.cellCount;
      }
      else if (this.tableSortBy == 'etholCount') {
        sortBy = this.holdersData.etholCount;
      }
      else if (this.tableSortBy == 'growthRate') {
        sortBy = this.holdersData.growthRate;
      }
      this.holders.sort((a, b) =>
        sortBy[a] < sortBy[b] ? 1 : -1
      );
    },

    copyText(text) {
      navigator.clipboard.writeText(text);
      this.$notify({
        text: "Address coppied to clipboard.",
        type: "success",
      });
    },

    renderPageIfReady() {
      if (!this.isLoading && this.etholdata.etholvants) {
        this.startPageRender();
      }
    },

    applyFilters() {
      var ids = this.tokenIds;

      var vm = this;

      // burned
      function notBurned(element) {
        return vm.etholdata["etholvants"][element][4] != null;
      }
      if (this.etholdata.etholvants[0].length > 4) {
        ids = ids.filter(notBurned);
      }

      // entered id
      var enteredId = this.enteredId.trim();
      if (
        enteredId >= this.tokenIds.length ||
        isNaN(enteredId) ||
        enteredId < 0
      ) {
        this.sortedIds = [];
        this.renderPageIfReady();
        return;
      }
      if (enteredId != "") {
        enteredId = parseInt(enteredId);
        ids = [enteredId];
      }

      // min cells
      var minCellsFil = 0;
      if (this.minCellsFilter) {
        minCellsFil = this.minCellsFilter.trim();
      }
      if (isNaN(minCellsFil)) {
        this.sortedIds = [];
        this.renderPageIfReady();
        return;
      }
      minCellsFil = parseInt(minCellsFil);
      function isGreater(element) {
        return vm.etholdata["etholvants"][element][1] >= minCellsFil;
      }

      ids = ids.filter(isGreater);

      // max cells
      var maxCellsFil = this.maxCells;
      if (this.maxCellsFilter) {
        maxCellsFil = this.maxCellsFilter.trim();
      }
      if (isNaN(maxCellsFil)) {
        this.sortedIds = [];
        this.renderPageIfReady();
        return;
      }
      maxCellsFil = parseInt(maxCellsFil);
      function isLess(element) {
        return vm.etholdata["etholvants"][element][1] <= maxCellsFil;
      }

      ids = ids.filter(isLess);

      this.sortedIds = ids;
      this.index = 0;
      this.renderPageIfReady();
    },

    nextPage() {
      if (this.index + this.pageSize < this.sortedIds.length) {
        this.index += this.pageSize;
        this.startPageRender();
      }
    },

    prevPage() {
      if (this.index < this.pageSize) {
        this.index = 0;
        this.startPageRender();
        return;
      }
      this.index -= this.pageSize;
      this.startPageRender();
    },

    firstPage() {
      this.index = 0;
      this.startPageRender();
    },

    view3D(tokenId) {
      var seed = this.etholdata.etholvants[tokenId][0];
      var numCells = this.etholdata.etholvants[tokenId][1];
      var newWindow = window.open();
      var content = this.script3d.replace("___SEED___", seed);
      content = content.replace("___NUMCELLS___", numCells);
      newWindow.document.write(content);
    },

    lastPage() {
      this.index =
        Math.floor(this.sortedIds.length / this.pageSize) * this.pageSize;
      this.startPageRender();
    },

    selectEthol(tokenId, event) {
      var card = event ? event.currentTarget : null;
      var slot = card ? card.closest(".cont-inline") : null;
      var topBefore = slot ? slot.getBoundingClientRect().top : null;
      var positionsBefore = this.getCardPositions();

      if (this.selectedId == tokenId) {
        this.selectedId = null;
        this.animateCardReflow(positionsBefore, slot, topBefore);
        return;
      }
      this._resetAnimated();
      this.selectedId = tokenId;
      this.animateCardReflow(positionsBefore, slot, topBefore);
    },

    getCardPositions() {
      var content = this.$refs.exploreContent;
      var positions = {};
      if (!content) {
        return positions;
      }

      content.querySelectorAll(".cont-inline[data-token-id]").forEach((el) => {
        positions[el.dataset.tokenId] = el.getBoundingClientRect();
      });
      return positions;
    },

    animateCardReflow(positionsBefore, selectedSlot, topBefore) {
      this.$nextTick(() => {
        var content = this.$refs.exploreContent;
        if (!content) {
          return;
        }

        if (selectedSlot && topBefore !== null) {
          var scrollDelta = selectedSlot.getBoundingClientRect().top - topBefore;
          if (Math.abs(scrollDelta) > 1) {
            window.scrollBy(0, scrollDelta);
          }
        }

        var moved = [];
        content.querySelectorAll(".cont-inline[data-token-id]").forEach((el) => {
          var before = positionsBefore[el.dataset.tokenId];
          if (!before) {
            return;
          }

          var after = el.getBoundingClientRect();
          var dx = before.left - after.left;
          var dy = before.top - after.top;
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) {
            return;
          }

          el.style.transition = "none";
          el.style.transform = "translate(" + dx + "px, " + dy + "px)";
          moved.push(el);
        });

        if (!moved.length) {
          return;
        }

        requestAnimationFrame(() => {
          moved.forEach((el) => {
            el.style.transition =
              "transform 360ms cubic-bezier(0.22, 1, 0.36, 1)";
            el.style.transform = "translate(0, 0)";
          });

          if (this.layoutAnimationTimer) {
            clearTimeout(this.layoutAnimationTimer);
          }
          this.layoutAnimationTimer = setTimeout(() => {
            moved.forEach((el) => {
              el.style.transition = "";
              el.style.transform = "";
            });
            this.layoutAnimationTimer = null;
          }, 420);
        });
      });
    },

    getScaled(tokenId) {
      const sourceCanvas = drawCanvas(
        this.etholdata.etholvants[tokenId][0],
        this.etholdata.etholvants[tokenId][1],
        this.etholdata.etholvants[tokenId][2]
      );
      var size = 1000;
      var canvas2 = document.createElement("canvas");
      canvas2.width = size;
      canvas2.height = size;
      var ctx2 = canvas2.getContext("2d");
      ctx2.fillStyle = "#FFF";
      ctx2.fillRect(0, 0, size, size);
      ctx2.imageSmoothingEnabled = false;
      ctx2.drawImage(sourceCanvas, 0, 0, size, size);
      return canvas2.toDataURL("image/jpeg");
    },

    downloadScaled(tokenId) {
      var link = document.createElement("a");
      link.href = this.getScaled(tokenId);
      link.download = tokenId;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    _resetAnimated() {
      this.animatedHist = {
        tokenId: null,
        numCells: null,
      };
    },

    _updateHist(tokenId, offsets, max) {
      if (tokenId != this.animatedHist.tokenId) {
        return;
      }
      var currCells = offsets.length * 2 + 2;
      if (currCells == max || this.selectedId != tokenId) {
        this._resetAnimated();
        return;
      }

      var seed = this.etholdata.etholvants[tokenId][0];

      var stepSize = Math.max(Math.floor(currCells * 0.01), 1);
      if (currCells + stepSize * 2 > max) {
        stepSize = (max - currCells) / 2;
      }
      offsets = addOffsets(seed, offsets, stepSize);
      this.animatedHist.numCells = offsets.length * 2 + 2;
      this.$nextTick(() => {
        if (tokenId != this.animatedHist.tokenId) {
          return;
        }
        var canvas = this.getAnimatedCanvas(tokenId);
        if (canvas) {
          drawOffsetsToCanvas(offsets, canvas);
        }
        setTimeout(() => {
          this._updateHist(tokenId, offsets, max);
        }, 100);
      });
    },

    animateHistory(tokenId) {
      if (!tokenId) return;
      if (tokenId == this.animatedHist.tokenId) return;
      this.animatedHist.tokenId = tokenId;
      this.selectedId = tokenId;
      var seed = this.etholdata.etholvants[tokenId][0];
      var numCells = this.etholdata.etholvants[tokenId][1];
      var offsets = addOffsets(seed, [], 11);
      this._updateHist(tokenId, offsets, numCells);
    },
  },
};
</script>

<style scoped>
.render-status {
  margin: 40px auto;
  text-align: center;
  font-size: 14px;
  color: #333;
}

.render-status .sk-chase {
  margin-top: 0;
  margin-bottom: 40px;
}

.render-status__timer {
  margin-top: 6px;
  font-family: monospace;
  color: #666;
}

.ethol img,
.ethol canvas {
  width: 100px;
  height: 100px;
  image-rendering: pixelated;
  transition:
    width 360ms cubic-bezier(0.22, 1, 0.36, 1),
    height 360ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ethol-img-placeholder {
  width: 100px;
  height: 100px;
  margin: auto;
  background:
    linear-gradient(90deg, #efefef 25%, #f8f8f8 50%, #efefef 75%);
  background-size: 200% 100%;
  animation: image-placeholder 1.2s infinite linear;
}

.ethol {
  --selected-ethol-size: min(40vw, 40vh);
  display: inline-block;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  vertical-align: top;
  transition:
    background-color 240ms ease,
    box-shadow 240ms ease;
}

.cont-inline {
  display: block;
  position: relative;
  vertical-align: top;
  will-change: transform;
}

.ethol:hover {
  background-color: #e2e1e1;
  cursor: pointer;
}

.selected {
  background-color: #f0f0f0;
  position: relative;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.12);
}

.selected img,
.selected canvas {
  width: var(--selected-ethol-size);
  height: var(--selected-ethol-size);
  margin: auto;
}

.selected .ethol-img-placeholder {
  width: var(--selected-ethol-size);
  height: var(--selected-ethol-size);
}

.caption {
  font-size: 14px;
  margin: 5px;
  margin-top: 10px;
  margin-bottom: -5px;
}

button {
  margin-left: 5px;
  margin-right: 5px;
}

.buttonsCont {
  margin-top: 20px;
  margin-bottom: 20px;
}

.etholCont {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;
  margin-bottom: 40px;
}

.pageNum {
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
}

input {
  padding: 8px;
  margin: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

input:focus {
  border: 1px solid rgba(0, 0, 0, 0.473);
  outline: none;
  transition: all 0.4s;
}

.selected {
  background-color: #f0f0f0;
}

.option {
  margin-top: 5px;
}

.crown {
  position: absolute !important;
  margin-left: -25px !important;
  margin-top: -60px !important;
  width: 50px !important;
  height: 50px !important;
}

.menu {
  margin-bottom: 40px;
}

.black {
  color: black;
}

.holdersDiv {
  overflow: scroll;
  margin: auto;
}

table tr:first-child {
    background: #efefef;
}

table {
  text-align: center;
}

.selectedSort {
    background: #e4e4e4;
}

.table-info {
  font-size: 14px;
  /* text-align: left; */
  margin: auto;
}

.clickable {
  cursor: pointer;
}

@keyframes image-placeholder {
  100% {
    background-position: -200% 0;
  }
}
</style>
